import { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { useMerchantsListQuery } from '~entities/merchant';
import { useGetPointsOfSalesQuery } from '~entities/pos';

import { MultiSelectFilter } from '~shared/ui/multi-select-filter';

import { getMerchantOptions, getStoreOptions } from '../../lib';
import type { DashboardFiltersValue } from '../../model/dashboard-filters';

type FieldProps = {
  onChange?: () => void;
};

export function BusinessSelect({ onChange }: FieldProps) {
  const { setValue } = useFormContext<DashboardFiltersValue>();
  const { data } = useMerchantsListQuery();
  const options = useMemo(() => getMerchantOptions(data ?? []), [data]);

  return (
    <MultiSelectFilter
      name="merchantIds"
      label="Businesses"
      options={options}
      onValueChange={() => {
        setValue('posIds', [], { shouldDirty: true });
        onChange?.();
      }}
    />
  );
}

export function StoreSelect({ onChange }: FieldProps) {
  const { data } = useGetPointsOfSalesQuery();
  const selectedMerchantIds = useWatch<DashboardFiltersValue, 'merchantIds'>({
    name: 'merchantIds',
  });
  const options = useMemo(
    () => getStoreOptions(data ?? [], selectedMerchantIds ?? []),
    [data, selectedMerchantIds]
  );

  return (
    <MultiSelectFilter
      name="posIds"
      label="Stores"
      options={options}
      onValueChange={onChange}
    />
  );
}
